var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var IconoRecomendadoDermatologos = function () {
    return (React.createElement(Icono, { src: "https://dikl249ktecee.cloudfront.net/_img_website/recomendado-dermatologos-2022.png", alt: "Recomendado por dermat\u00F3logos" }));
};
var Icono = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 50px;\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 50px;\n"])));
export default IconoRecomendadoDermatologos;
var templateObject_1;
